"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

var _env = require("../../utils/env");

var _env2 = _interopRequireDefault(_env);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BotSessionsService = function BotSessionsService(HttpService) {
  "ngInject";

  var getDataSource = function getDataSource(successCb) {
    var dataSource = new kendo.data.DataSource({
      transport: {
        read: {
          url: _env2.default.getApiUrl("bigfoot/bot-sessions/search"),
          contentType: "application/json",
          type: "POST",
          beforeSend: _onBeforeSend

        },
        parameterMap: _parameterMap
      },
      change: successCb,
      schema: {
        data: "data",
        total: "total"
      },
      serverFiltering: true,
      serverPaging: true,
      serverSorting: true,
      pageSize: 50
    });

    return dataSource;
  };

  var getSessionDetails = function getSessionDetails(sessionId, successCb, failureCb) {
    HttpService.get("bigfoot/bot-sessions/" + sessionId, successCb, failureCb);
  };

  var getMessagesDataSource = function getMessagesDataSource(sessionId, successCb) {
    var dataSource = new kendo.data.DataSource({
      transport: {
        read: {
          url: _env2.default.getApiUrl("bigfoot/bot-sessions/" + sessionId + "/messages"),
          contentType: "application/json",
          type: "GET",
          beforeSend: _onBeforeSend

        }
      },
      change: successCb,
      serverFiltering: false,
      serverPaging: false,
      serverSorting: false,
      pageSize: 50
    });

    return dataSource;
  };

  return {
    getDataSource: getDataSource,
    getSessionDetails: getSessionDetails,
    getMessagesDataSource: getMessagesDataSource
  };
};

function _onBeforeSend(req) {
  var token = "Bearer " + window.localStorage.getItem("bigfootAccessToken");

  req.setRequestHeader("Authorization", token);
}

function _parameterMap(data, type) {
  var filters = [];

  if (data.filter) filters = data.filter.filters;

  var query = (0, _assign2.default)({}, { filters: filters }, data);
  delete query.filter;

  console.log("Query::", query);

  return (0, _stringify2.default)(query);
}

exports.default = BotSessionsService;


/** WEBPACK FOOTER **
 ** ./client/app/common/services/bot-sessions.service.js
 **/